import { KeyboardEvent, useState } from 'react'

import { BiSend } from 'react-icons/bi'

import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'

const DEFAULT_PLACEHOLDER = 'Ask about SOPs for this incident...'
const SEND_BUTTON_LABEL = 'Send message'

interface ChatInputIProps {
  onSend: (message: string) => void
  isDisabled?: boolean
  placeholder?: string
}

export const ChatInput = ({
  onSend,
  isDisabled,
  placeholder = DEFAULT_PLACEHOLDER,
}: ChatInputIProps) => {
  const [value, setValue] = useState('')

  const handleSend = () => {
    if (!value.trim() || isDisabled) return
    onSend(value.trim())
    setValue('')
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <InputGroup size='md'>
      <Input
        disabled={isDisabled}
        fontSize='14px'
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        pr='40px'
        value={value}
      />
      <InputRightElement>
        <IconButton
          aria-label={SEND_BUTTON_LABEL}
          colorScheme='blue'
          disabled={!value.trim() || isDisabled}
          icon={<Icon as={BiSend} />}
          onClick={handleSend}
          size='sm'
          variant='ghost'
        />
      </InputRightElement>
    </InputGroup>
  )
}
